import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const API_URL = "https://wip.technicalcreatives.lk/api/users.php";

function ResetPassword() {
  const [form, setForm] = useState({
    email: "",
    password: "",
    re_password: "",
  });

  const [passwordError, setPasswordError] = useState("");
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d@$!%*?&^#_~\-]{8,}$/;

  const passwordMismatch =
    form.re_password && form.password !== form.re_password;

  const isFormValid =
    form.email.trim() !== "" &&
    form.password.trim() !== "" &&
    !passwordError &&
    !passwordMismatch;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) return;

    try {
      const response = await axios.post(
        `${API_URL}?action=reset-password`,
        { email: form.email, password: form.password }
      );

      if (response.data.success) {
        alert("Password reset successfully. Please login.");
        navigate("/");
      } else {
        alert(response.data.message || "Failed to reset password");
      }
    } catch (error) {
      alert("Error resetting password. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded shadow-md w-full max-w-md"
      >
        <h2 className="text-2xl font-bold mb-4">Reset Password</h2>

        <input
          type="email"
          placeholder="Enter your email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="w-full px-4 py-2 border rounded mb-4"
          required
        />

        <div className="mb-4">
          <div className="relative">
            <input
              type={visible ? "text" : "password"}
              placeholder="New Password"
              value={form.password}
              onChange={(e) => {
                const value = e.target.value;
                setForm({ ...form, password: value });
                setPasswordError(
                  passwordRegex.test(value) || value === ""
                    ? ""
                    : "Password must be at least 8 characters, with uppercase, lowercase, number & symbol."
                );
              }}
              className={`w-full px-4 py-2 border ${
                passwordError ? "border-red-500" : "border-gray-300"
              } rounded focus:outline-none focus:ring-2 ${
                passwordError ? "focus:ring-red-500" : "focus:ring-blue-500"
              }`}
              required
            />
            <button
              type="button"
              onClick={() => setVisible(!visible)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
            >
              {visible ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>
          {passwordError && (
            <p className="text-red-500 text-sm mt-1">{passwordError}</p>
          )}
        </div>

        <div className="mb-4">
          <input
            type="password"
            placeholder="Confirm New Password"
            value={form.re_password}
            onChange={(e) =>
              setForm({ ...form, re_password: e.target.value })
            }
            className={`w-full px-4 py-2 border ${
              passwordMismatch ? "border-red-500" : "border-gray-300"
            } rounded focus:outline-none focus:ring-2 ${
              passwordMismatch ? "focus:ring-red-500" : "focus:ring-blue-500"
            }`}
            required
          />
          {passwordMismatch && (
            <p className="text-red-500 text-sm mt-1">
              Passwords do not match.
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={!isFormValid}
          className={`w-full text-white py-2 rounded transition ${
            !isFormValid
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          Confirm Reset
        </button>
      </form>
    </div>
  )
}

export default ResetPassword;
